import { isMobileOnly } from 'react-device-detect';
import {
  PHONE_TITLE,
} from '../pages/components/tableData';
import {
  NO,
  SUBSCRIBE_MESSAGES,
  UNSUBSCRIBE_MESSAGES,
  UPDATE_SUCCESS,
  YES
} from '../pages/constants';
import { formatPhone } from '../pages/components/common/helper';

export const isSsr = typeof window === 'undefined';

let customerType = 'b2c';

export function setCustomerType(type) {
  switch (type) {
  case 'b2c':
  case 'b2b':
    customerType = type; break;
  default:
    customerType = 'b2c';
  }
}

export const getHost = () => {
  if (isSsr) return '';

  if (process.env.NODE_ENV === 'production' && !process.env.DOMAIN_NAME) {
    return `https://${window.location.hostname}`;
  }

  return window.location.origin;
};

export function getAuthorizationToken() {
  return !isSsr ? window.THDCustomer?.default?.token || '' : '';
}

export function getSvocId() {
  return isSsr ? null : window.THDCustomer?.default?.svocID || '';
}

export function isB2CUser() {
  return customerType === 'b2c';
}

export function getUserId() {
  return isSsr ? null : window.THDCustomer?.default?.userID || '';
}

export function isLoggedIn() {
  return isSsr ? false : (window.THDCustomer?.default?.isLoggedIn || false);
}

export function getChannelID() {
  return (isMobileOnly ? 2 : 1);
}

export function generateXB3TraceID() {
  return Math.random().toString(16).substring(2) + new Date().getTime().toString(16).substring(0, 15);
}

export function getSignInPath() {
  return isSsr ? '' : `/auth/view/signin?redirect=${window.location.pathname}`;
}

export function getString(data) {
  if (!data) {
    return '';
  }
  return data.trim();
}

export function containsOptIn(list, table) {
  return list.some((title) => table[title].value === YES);
}

export function containsTelemarketing(list) {
  return list.some((title) => title === PHONE_TITLE);
}

export function scrollToBanner(scrollToAlert) {
  const offsetHeader = 150;
  const { top } = scrollToAlert.current.getBoundingClientRect();
  window.scrollTo({
    top: window.scrollY + top - offsetHeader,
    behavior: 'smooth',
  });
}

export function formatEmail(val) {
  if (!val) {
    return '';
  }
  return val.trim().toLowerCase();
}

export function formatAddress(val) {
  if (!val || !val.addressLine1) {
    return '';
  }
  const addr1and2 = val.addressLine2
    ? val.addressLine1 + ' ' + val.addressLine2 + ', '
    : val.addressLine1 + ', ';
  const address = [
    val.city,
    val.state,
  ].filter(Boolean);
  return addr1and2 + address.join(', ') + ' ' + val.zip5;
}

export function formatIntake(intake) {
  if (typeof intake === 'string' && intake.includes('.') && intake.includes('@')) {
    return formatEmail(intake);
  } if (typeof intake === 'object' && intake.addressLine1) {
    return formatAddress(intake);
  }
  return formatPhone(intake);
}

export function determineMessage(selectedItems, emailTableData) {
  const newSelectedOptOuts = selectedItems
    .filter((key) => emailTableData[key].value === NO)
    .map((key) => emailTableData[key].type);

  const newSelectedOptIns = selectedItems
    .filter((key) => emailTableData[key].value === YES)
    .map((key) => emailTableData[key].type);

  const messages = [];

  newSelectedOptOuts.forEach((type) => {
    if (UNSUBSCRIBE_MESSAGES[type]) {
      messages.push(UNSUBSCRIBE_MESSAGES[type]);
    }
  });

  newSelectedOptIns.forEach((type) => {
    if (SUBSCRIBE_MESSAGES[type]) {
      messages.push(SUBSCRIBE_MESSAGES[type]);
    }
  });

  return messages.length > 0 ? messages : [UPDATE_SUCCESS];
}
